import { server } from "lib/app-server"

/**
 * Checks if SSO is available for a given email address.
 * This is a public endpoint (no auth required).
 * @param {string} email - The user's email address.
 * @returns {Promise<{ssoAvailable: boolean, configId?: string, providerName?: string}>}
 */
export async function checkSSO(email) {
    console.log("[SSO check] Checking SSO for email:", email)
    try {
        const url = "/auth/sso/check"
        console.log("[SSO check] POSTing to server():", url)
        const response = await server(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
        })
        console.log("[SSO check] Response status:", response.status, response.url)
        if (response.ok) {
            const result = await response.json()
            console.log("[SSO check] Result:", JSON.stringify(result))
            return result
        }
        console.warn("[SSO check] Non-OK response:", response.status)
        return { ssoAvailable: false }
    } catch (e) {
        console.error("[SSO check] Failed:", e)
        return { ssoAvailable: false }
    }
}
